import { useMutation } from '@tanstack/react-query';
import { api } from '@app/utils/api';
import { errorHandler } from '@app/utils/errorHandler';
import { IMainIndicatorsFilter } from 'pages/Main/components/Filter';
import { BI_BASE_URL } from '@app/contstants/endpoints';
import { IBoeingNewAccounts } from '@entities/boeing/IBoeingNewAccounts';
import { buildDateParams } from '@app/utils/buildDateParams';

export const fetch = async (filters: IMainIndicatorsFilter): Promise<IBoeingNewAccounts> => {
  const params = buildDateParams(filters);

  const response = await api.get<IBoeingNewAccounts>(`${BI_BASE_URL}/boeing/new/accounts`, {
    params: {
      manager_ids: filters.managers,
      region: filters.regions,
      tag: filters.tags,
      source: filters.sources,
      coins: filters.coins,
      ...params,
    },
  });

  return response.data ?? [];
};

export const useBoeingNewAccounts = () => {
  const { mutateAsync, isError, isPending, isSuccess, error } = useMutation({
    mutationFn: fetch,
    onError: error => errorHandler(error),
  });

  return {
    fetch: mutateAsync,
    isError,
    isPending,
    isSuccess,
    error,
  };
};
